import { ActionTree } from "vuex";
import {
  ChangePartnerUserRole,
  PartnerUserRoleFilter,
  PartnerUserRolesItem,
  PartnerUserRolesState,
} from "@/store/user_management/partner_user_roles/types";
import { RootState } from "@/store/types";
import axios from "axios";
import { directDownload } from "@/utils/download-helper";
import Axios from "axios";

export const actions: ActionTree<PartnerUserRolesState, RootState> = {
  getPartnerUserRoles: ({ commit }, data) => {
    commit("setLoading", true);
    return new Promise((resolve, reject) => {
      Axios({ url: "/acapi/partner_user_roles", params: data })
        .then((resp) => {
          commit("setPartnerUserRoles", resp.data.roles);
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => commit("setLoading", false));
    });
  },
  getPartnerUserRoleItem: async ({ commit, dispatch }, id?: number) => {
    commit("setLoading", true);
    try {
      let resp = await axios({ url: `/acapi/partner_user_roles/${id ?? "current"}` });
      let partnerUserRolesItem = <PartnerUserRolesItem>resp.data;
      partnerUserRolesItem.id = id;
      commit("setPartnerUserRolesItem", partnerUserRolesItem);
      return partnerUserRolesItem;
    } catch (err) {
      throw err;
    } finally {
      commit("setLoading", false);
    }
  },
  savePartnerUserRole: ({ commit, dispatch }, data: PartnerUserRolesItem) => {
    commit("setLoading", true);
    // Тут такое не разбериха нужно было добавить header при изменении ролей
    axios.defaults.headers["Request-Change-Permissions"] = true;
    return new Promise((resolve, reject) => {
      axios({
        method: data.id ? "put" : "post",
        url: "/acapi/partner_user_roles/" + (data.id ?? ""),
        data: data,
      })
        .then((resp: any) => {
          resolve(resp);
        })
        .catch((err: any) => {
          // errorNotify(err);
          reject(err);
        })
        .finally(() => {
          // соответственно я его удаляю
          delete axios.defaults.headers["Request-Change-Permissions"];
          commit("setLoading", false);
        });
    });
  },
  changePartnerUserRole: ({ commit, dispatch }, data: ChangePartnerUserRole) => {
    commit("setLoading", true);
    return new Promise((resolve, reject) => {
      axios({
        method: "put",
        url: `/acapi/partner_users/role/${data.old_role_id}`,
        data: data.new_role_id,
      })
        .then((resp: any) => {
          resolve(resp);
        })
        .catch((err: any) => {
          reject(err);
        })
        .finally(() => {
          commit("setLoading", false);
        });
    });
  },
  deletePartnerUserRole: ({ commit, dispatch }, data: PartnerUserRolesItem) => {
    commit("setLoading", true);
    return new Promise((resolve, reject) => {
      axios({
        method: "delete",
        url: `/acapi/partner_user_roles/${data.id}`,
        data: data,
      })
        .then((resp: any) => {
          dispatch("getPartnerUserRoles");
          resolve(resp);
        })
        .catch((err: any) => {
          reject(err);
        })
        .finally(() => commit("setLoading", false));
    });
  },
  exportPartnerUserRoles: ({ commit, dispatch }, data: PartnerUserRoleFilter) => {
    return directDownload("/acapi/partner_user_roles/export", data);
  },

  getPartnerUserPageBlocks: ({ commit }, data) => {
    commit("setLoading", true);
    return new Promise((resolve, reject) => {
      Axios({ url: "/acapi/partner_users/page_blocks", params: data })
        .then((resp) => {
          commit("setPageBlocks", resp.data.page_blocks);
          resolve(resp.data.page_blocks);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => commit("setLoading", false));
    });
  },
};
